<template>
  <div class="login_common_box">
    <login-header :isAlibabaSite="isAlibabaSiteTalg" v-if="!fromListing"></login-header>
    <router-view></router-view>
    <login-footer :isAlibabaSite="isAlibabaSiteTalg"></login-footer>
    <fixedRightNav source="login"></fixedRightNav>
  </div>
</template>

<script>
import loginHeader from "./header";
import loginFooter from "./footer";
import {commonSessionStorage, getDomainSiteInfo} from '@/utils/common';
import fixedRightNav from "@/components/common/fixedRightNav.vue";

export default {
  data() {
    return {
      isAlibabaSite: false
    };
  },
  components: {
    fixedRightNav,
    loginHeader,
    loginFooter
  },
  computed: {
    fromListing() {
      return this.$store.state.fromListing;
    },
    isAlibabaSiteTalg() {
      return this.isAlibabaSite;
    }
  },
  created() {
    this.loadTheme();
    this.isAlibabaDomain();
  },
  methods: {
    async loadTheme() {
      if (this.$loadProjectTheme) {
        await this.$loadProjectTheme();
      }
    },
    isAlibabaDomain() {
      this.isAlibabaSite = false;
      getDomainSiteInfo().then((data) => {
        this.isAlibabaSite = data.some((item) => {
          return item.merchantType === 'ALIGJ';
        });
        commonSessionStorage.setItem('isAlibabaSite', this.isAlibabaSite);
        this.loadTheme();
      });
    }
  }
};
</script>

<style scoped>
.login_common_box {
  width: 100%;
  height: 100vh;
  background-color: #fff;
  position: relative;
  overflow: hidden;
}
</style>
